import { render } from "./Footer.vue?vue&type=template&id=34abe208&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=34abe208&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34abe208"

export default script